import {
  AvroOptional,
  log as signalsLogGraphQLOperation,
} from "@indeed/signals-schema/com/indeed/signals/schema/reactnative/RNGraphQLOperationV2";

import { getDeviceProperties } from "./LoggableDeviceProperties";

interface GraphQLOperationLogParams {
  subApp: string | null;
  operationName: string | null;
  durationMs: number;
  success: boolean;
  errorMessage?: string;
  ctk?: string | null;
}

export function logGraphQLOperation({
  subApp,
  operationName,
  durationMs,
  success,
  errorMessage,
  ctk,
}: GraphQLOperationLogParams): void {
  signalsLogGraphQLOperation({
    deviceProperties: getDeviceProperties(),
    subApp: AvroOptional.string(subApp),
    operationName: AvroOptional.string(operationName),
    durationMs,
    success,
    errorMessage: AvroOptional.string(errorMessage),
    ctk: AvroOptional.string(ctk),
  });
}
